import { module } from 'angular';

import { default as popupTransferName, PopupTransfer } from './popup-transfer.component';

export default module('contact.agent.core.agent.transfer.popup', []).component(popupTransferName, new PopupTransfer()).name;
